import { useState } from 'react';
import { AiReviewCell } from '@/components/AiReviewCell';
import { AiReviewDialog } from '@/components/AiReviewDialog';
import { BillVersion, Bill } from '@/types/bill';

interface PrintAIReviewButtonProps {
  latestVersion: BillVersion;
  bill: Bill;
  loadingAction?: string;
}

export function PrintAIReviewButton({ latestVersion, bill, loadingAction }: PrintAIReviewButtonProps) {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  return (
    <>
      <AiReviewCell
        bill={bill}
        latestVersion={latestVersion}
        loadingAction={loadingAction}
        onClick={handleOpenDialog}
      />

      <AiReviewDialog
        bill={bill}
        latestVersion={latestVersion}
        open={dialogOpen}
        onOpenChange={setDialogOpen}
      />
    </>
  );
}